import React from 'react';
import Footer from '../component/Footer';

// Importing images for all treatments
import cancer from '../pages/images/cancer.jpg';
import cardiacCare from '../pages/images/cardic.jpg';
import neurosciences from '../pages/images/neurosciences.jpg';
import gastrosciences from '../pages/images/gastrosciences.jpg';
import orthopaedics from '../pages/images/orthopaedics.jpg';
import renalCare from '../pages/images/RenalCare.jpg';
import ent from '../pages/images/ent.jpg';
import boneMarrow from '../pages/images/bone.jpg';
import chestCare from '../pages/images/chest.jpg';
import emergency from '../pages/images/emergency.jpg';
import gynaecology from '../pages/images/gyneology.jpg';
import liverCare from '../pages/images/liver.jpg';
import lungsCare from '../pages/images/lungs.jpg';
import obstetrics from '../pages/images/obstetic.jpg';
import plasticSurgery from '../pages/images/plastic.jpg';

const Treatments = () => {
    const treatments = [
        { name: 'Cancer Care', image: cancer },
        { name: 'Cardiac Care', image: cardiacCare },
        { name: 'Neurosciences', image: neurosciences },
        { name: 'Gastrosciences', image: gastrosciences },
        { name: 'Orthopaedics', image: orthopaedics },
        { name: 'Renal Care', image: renalCare },
        { name: 'Ear, Nose, Throat', image: ent },
        { name: 'Bone Marrow', image: boneMarrow },
        { name: 'Chest', image: chestCare },
        { name: 'Emergency', image: emergency },
        { name: 'Gynaecology', image: gynaecology },
        { name: 'Liver', image: liverCare },
        { name: 'Lungs Care', image: lungsCare },
        { name: 'Obstetrics', image: obstetrics },
        { name: 'Plastic Surgery', image: plasticSurgery }
    ];

    return (
        <>
            <div className="container">
                <div className="text-center my-5">
                    <h1>Our Treatments</h1>
                </div>

                <div className="row">
                    {treatments.map((treatment, index) => (
                        <div className="col-md-4 my-3" key={index}>
                            <div className="treatment-card">
                                <img
                                    src={treatment.image}
                                    alt={treatment.name}
                                    className="img-fluid treatment-img"
                                />
                                <h4>{treatment.name}</h4>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <Footer />
        </>
    );
}

export default Treatments;
